import { useEffect, useState } from "react";
import { fetchPlanos } from "../services/billingApi";

export const PRICES_STATUS = {
  LOADING: "loading",
  READY: "ready",
  ERROR: "error",
};

/**
 * Preços indexados por plano_chave. Em caso de falha devolve `prices` vazio:
 * a página segue navegável e cada plano mostra "valor indisponível".
 */
export const usePlanPrices = () => {
  const [state, setState] = useState({ status: PRICES_STATUS.LOADING, prices: {} });

  useEffect(() => {
    const controller = new AbortController();

    fetchPlanos({ signal: controller.signal })
      .then((planos) => {
        const prices = Object.fromEntries(planos.map((plano) => [plano.plano_chave, plano]));
        setState({ status: PRICES_STATUS.READY, prices });
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        console.error("Não foi possível carregar os preços dos planos.", error);
        setState({ status: PRICES_STATUS.ERROR, prices: {} });
      });

    return () => controller.abort();
  }, []);

  return state;
};
